import type { SystemStyleObject } from '@mui/system';

export const ParagraphStyle: SystemStyleObject = {
    fontFamily: 'Equip_Regular',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    color: '#242424',
};
